import { render } from "./ProductDetailsPages.vue?vue&type=template&id=c295508a&scoped=true"
import script from "./ProductDetailsPages.vue?vue&type=script&lang=js"
export * from "./ProductDetailsPages.vue?vue&type=script&lang=js"

import "./ProductDetailsPages.vue?vue&type=style&index=0&id=c295508a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c295508a"]])

export default __exports__